import { RouteEnum } from "@@/enums/RouteEnum.js";
import { useLocaleStore } from "@@/stores/useLocaleStore";

export const RouteExistsMiddleware = ({ to, next }) => {
	const locale = Array.isArray(to.params.path) && to.params.path.length ? to.params.path[0] : useLocaleStore().getLocale;
	return { name: RouteEnum.ERROR_404, params: { locale: locale } };
};

export default RouteExistsMiddleware;
